"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderBanner = void 0;
var React = require("react");
var renderBanner = function () {
    var imageName = 'newsletter';
    var iconName = 'newsletter-checked';
    return (React.createElement("div", { className: "row newsletter-promo" },
        React.createElement("div", { className: "col-sm-9 newsletter-bullets" },
            React.createElement("div", { className: "newsletter-bullet" },
                React.createElement("span", null,
                    React.createElement("img", { src: "/static/images/" + iconName + ".svg", alt: iconName })),
                React.createElement("span", null, "Exclusive insights by our industry experts")),
            React.createElement("div", { className: "newsletter-bullet" },
                React.createElement("span", null,
                    React.createElement("img", { src: "/static/images/" + iconName + ".svg", alt: iconName })),
                React.createElement("span", null, "Be the first to know about upcoming events")),
            React.createElement("div", { className: "newsletter-bullet" },
                React.createElement("span", null,
                    React.createElement("img", { src: "/static/images/" + iconName + ".svg", alt: iconName })),
                React.createElement("span", null, "Get important news without searching for it (no spam)"))),
        React.createElement("div", { className: "col-sm-3 newsletter-bullets-image" },
            React.createElement("img", { src: "/static/images/" + imageName + ".svg", alt: imageName }))));
};
exports.renderBanner = renderBanner;
